import LearnTriautoTabs from './LearnTriautoTabs';

export default LearnTriautoTabs;
